var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54887 6.06181L5.84937 8.2214C5.65035 8.38063 5.36342 8.36474 5.1832 8.18451L3.81552 6.81683C3.63529 6.6366 3.6194 6.34968 3.77862 6.15065L5.93822 3.45115C6.92574 2.21675 8.42084 1.49817 10.0016 1.49817V1.49817C10.2779 1.49817 10.5019 1.72212 10.5019 1.99838V1.99838C10.5019 3.57918 9.78328 5.07428 8.54887 6.06181Z",
    stroke: "#525866",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0008 6.50024V8.69216C8.0008 8.88162 7.89375 9.05482 7.72429 9.13955L6.51582 9.74381C6.38612 9.80865 6.23467 9.81403 6.1007 9.75854C5.96673 9.70304 5.86344 9.59215 5.81758 9.45459L5.49976 8.50108",
    stroke: "#525866",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49893 6.50031L2.54546 6.18248C2.40789 6.13663 2.297 6.03333 2.24151 5.89937C2.18602 5.7654 2.19139 5.61394 2.25624 5.48425L2.86049 4.27578C2.94521 4.10633 3.1184 3.99927 3.30786 3.99927H5.49977",
    stroke: "#525866",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.87373 10.2952L1.49811 10.5019L1.70477 9.12625C1.77181 8.67999 2.12212 8.32968 2.56837 8.26264V8.26264C2.89085 8.21419 3.21718 8.32165 3.44777 8.55223C3.67835 8.78282 3.78582 9.10915 3.73736 9.43163V9.43163C3.67031 9.87788 3.31999 10.2282 2.87373 10.2952V10.2952Z",
    stroke: "#525866",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.1b33582f22b0c8e3082d4970914d86de.svg";
export { ForwardRef as ReactComponent };